import Styled from 'styled-components'

export const Wrapper = Styled.div`
    border: 1px solid olive;
    background:#FDFFF0;
    border-radius: ${(props) => props.theme.formControlBorderRadius};
    padding-top: 10px;
  padding-bottom: 10px;
`
